export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

import { SPECIALISTS } from '../workflow/VisitBits';

export const RELATIONSHIPS = ['Principle', 'Spouse', 'Son', 'Daughter', 'Father', 'Mother', 'Child', 'Dependent'];
// Base roles; the generic "Specialist" role is offered as one option per specialty (stored as role Specialist + specialty)
export const BASE_ROLES = ['Admin', 'Finance', 'Reception', 'DataEntry', 'Consultant', 'Gynaecologist', 'Pharmacist', 'Lab', 'Radiology'];
export const SPECIALTY_ROLES = SPECIALISTS.filter((s) => !['Gynaecologist', 'Obstetrician'].includes(s)); // Gynae/Obstetrics are one role
export const ROLE_OPTIONS = [
  ...BASE_ROLES.map((r) => ({ value: r, role: r, specialty: null })),
  ...SPECIALTY_ROLES.map((s) => ({ value: `Specialist:${s}`, role: 'Specialist', specialty: s })),
];
export const roleOptionValue = (user) => (user?.role === 'Specialist' && user?.specialty ? `Specialist:${user.specialty}` : user?.role || 'Admin');
// 'Consultant' stays as the internal role value; general doctors run the consultations
export const roleLabel = (r, specialty) => {
  if (r === 'Consultant') return 'General Doctor';
  if (r === 'Gynaecologist') return 'Gynaecologist / Obstetrician';
  if (r === 'Specialist') return specialty ? `${specialty} (Specialist)` : 'Specialist — specialty not set';
  return r;
};

export const ITEMS_PER_PAGE = 20;
export const FAMILIES_MEMBERS_PER_PAGE = 100;
export const PRICELISTS_PER_PAGE = 100;
export const CLAIMS_PER_PAGE_DEFAULT = 20;
export const CLAIMS_PER_PAGE_FILTERED = 100;

export const toISODate = (value) => {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  if (typeof value === 'string') {
    const slashMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slashMatch) {
      const [, month, day, year] = slashMatch;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    const dashMatch = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (dashMatch) {
      const [, day, month, year] = dashMatch;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return `${String(d.getFullYear()).padStart(4, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  } catch {
    return '';
  }
};

export const toNumberOrUndefined = (value) => {
  if (value === null || value === undefined) return undefined;
  const s = String(value).replace(/,/g, '').trim();
  if (s === '') return undefined;
  const n = Number(s);
  return Number.isFinite(n) ? n : undefined;
};

export const formatCurrency = (amount, currency) => {
  const symbol = currency?.symbol || '$';
  const decimals = currency?.decimal_places !== undefined ? currency.decimal_places : 2;
  const formattedAmount = amount.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${symbol} ${formattedAmount}`;
};

export const paginate = (array, page, pageSize = ITEMS_PER_PAGE) => {
  const startIndex = (page - 1) * pageSize;
  return array.slice(startIndex, startIndex + pageSize);
};

export const getTotalPages = (arrayLength, pageSize = ITEMS_PER_PAGE) => Math.ceil(arrayLength / pageSize);

export const toggleSelectItem = (id, selectedItems, setSelectedItems) => {
  if (selectedItems.includes(id)) {
    setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
  } else {
    setSelectedItems([...selectedItems, id]);
  }
};

export const toggleSelectAll = (items, selectedItems, setSelectedItems, idField) => {
  if (selectedItems.length === items.length) {
    setSelectedItems([]);
  } else {
    setSelectedItems(items.map((item) => item[idField]));
  }
};

export const errDetail = (error, fallback = 'Operation failed') => {
  const detail = error.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(' | ');
  return detail || fallback;
};
